export const platforms = [
  'AskMe',
  'eCommerce',
  'Examensprint',
  'Graveyard',
  'Hogeschooltaal',
  'ILhub',
  'Informat',
  'LearningHub',
  'LearnLinq',
  'LiberDownloadable',
  'LibereLabb',
  'LiberOnline',
  'LiberWebApp',
  'MijnKlas',
  'Noordhoffzorg',
  'PEP',
  'PLP',
  'ScoodlePE',
  'ScoodleSE',
  'SeAtlas',
  'SEP',
  'SIMS',
  'Studiemeister',
  'Testbed',
  'Toetsplatform',
  'LXAssetManagerTool',
  'ValuePicking',
  'LiberOnlinebok',
  'Sowiso',
  'Edify',
] as const;

const platformConfiguration: Record<Platform, PlatformConfiguration> = {
  AskMe: {
    rudder: { acceptanceKey: '2MTcTBzzl3UFeXjWxl9g02ddPQb', productionKey: '2MTd5PG5uLmHmgSJ3xFrQEWQB8p' },
  },
  eCommerce: {
    rudder: {
      acceptanceKey: '2MTcbZRwoEtjb0UinOeO6lQx7YE',
      productionKey: '2MTd8MjPlFb9xniwB0KJSzh6ppU',
      startImmediately: false,
    },
    gtm: { enabled: true, startImmediately: false },
  },
  Noordhoffzorg: {
    /* 3rd party website for professional  */
    rudder: { acceptanceKey: '2Q8hjCPA2VTpCAnI5GVuplKmUmo', productionKey: '2Q8hklWcNxsYeuNABVl7LaOvjv9' },
  },
  Examensprint: {
    rudder: { acceptanceKey: '2MTcdKg4WXimFRwAFvFThzk6aBA', productionKey: '2MTdALLX7thF1LpQqqpDVzc6M46' },
  },
  Graveyard: {
    rudder: { acceptanceKey: '2MTcjWSHh718oCiEfozRqpjQe0c', productionKey: '2MTdCDAQtxu2gcxMWsLC5KnDOjx' },
  },
  Hogeschooltaal: {
    rudder: { acceptanceKey: '2Pv0lDMyIAXQp5UBy90ozbxIVgx', productionKey: '2Pv0hoWMrLeDc768oS28uIdK3Ki' },
  },
  ILhub: {
    rudder: { acceptanceKey: '2MTcl9Q9cqugpxJuUputRFhAkF3', productionKey: '2MTdEXocXrTIqDrmbw1zPWiUNpB' },
  },
  Informat: {
    rudder: { acceptanceKey: '2MTcn9Gk2UmP6d8BbR76Ot9y4mM', productionKey: '2MTdFzNIcTNbZ1ZhTyP0ji8ZEJ4' },
  },
  LearningHub: {
    rudder: { acceptanceKey: '2MTcoid09XyK0yhMKi2OZEMVlv2', productionKey: '2MTdHJlKxcTg8Wdg2hPX1MRYWpc' },
  },
  LearnLinq: {
    rudder: { acceptanceKey: '2O0aZOcGJ0faEjWxpC5W3lWjUWo', productionKey: '2O0ak6Uzh2m4Opommrnef09DLG2' },
  },
  LiberDownloadable: {
    rudder: { productionKey: '2UKccd4FGJCYQzOyT2a3KHmdBOX' },
  },
  LibereLabb: {
    rudder: { productionKey: '2UKd6ZkfRgYt5eFBstm8NvXOfXI' },
  },
  LiberOnline: {
    rudder: { productionKey: '2UIV6U1kFHTFBOU5PjbQ20VkndZ' },
  },
  LiberWebApp: {
    rudder: { productionKey: '2UIVKagDgl9dk83wxVr5vwRKcMI' },
  },
  MijnKlas: {
    rudder: { acceptanceKey: '2MTcq8iR0X5jaVTHVcfKd21HLVd', productionKey: '2MTdKWHzskHORKE7vN4eophAdBt' },
  },
  PEP: {
    rudder: { acceptanceKey: '2MTcsJy2knW1yzFWFR58CJYIFp4', productionKey: '2MTdOVxsogxKUTYTNbHXx5f6i1Q' },
  },
  PLP: {
    rudder: { acceptanceKey: '2MTctdSzMxa95IFMbumrzHbdkyW', productionKey: '2MTdQ14fbVKLJLiXTCEGVHGzdt6' },
  },
  ScoodlePE: {
    rudder: { acceptanceKey: '2MTcvNhzLXWbklR6m3TBG5Umckh', productionKey: '2MTdRARYaChhEsfd8XvvotBYbie' },
  },
  ScoodleSE: {
    rudder: { acceptanceKey: '2MTcxxn3XAUDuypFEbRwokL29GM', productionKey: '2MTdUi83cOJP22xZeHFGFjphfzt' },
  },
  SeAtlas: {
    rudder: { acceptanceKey: '2NTAUH8EqqbHMhdzSO2giWZKg8h', productionKey: '2NTAfO0ct1UbNnIWPBDi1exTVAz' },
  },
  SEP: {
    rudder: { acceptanceKey: '2MTczVHnwwcXwL8gVP0MzRXI6a2', productionKey: '2MTdWJa9yBQTsu9CCum2F38TGoC' },
  },
  SIMS: {
    rudder: { acceptanceKey: '2YqHRgLEITWUadw1hmxt7UOSGWW', productionKey: '2YqHUKFiQolDFWlHXWTdrJmFPfi' },
  },
  Studiemeister: {
    rudder: { acceptanceKey: '2MTd2KM7vFEowH6P1JOGFasub37', productionKey: '2MTdYCfVWmemo58B225J5PjjuYa' },
  },
  Testbed: {
    rudder: { acceptanceKey: '2MQAqetMNKadP3y2RqtsnbJoB37', productionKey: '2QVcZhsty5azhgJSBRN54VgE2uN' },
    gtm: { enabled: true, startImmediately: false },
  },
  Toetsplatform: {
    rudder: { acceptanceKey: '2MTd3XCZx3bLrSQ448wSdocFV35', productionKey: '2MTdZTUTeFPsnEflmsDYAcT43gu' },
  },
  LXAssetManagerTool: {
    rudder: { acceptanceKey: '2cMNQYt82KhRkEUNiH06HO3Tz9m', productionKey: '2cMNTS8ngVs9QvBI7nHdktmUfuA' },
  },
  ValuePicking: {
    rudder: { acceptanceKey: '2cMN6YDrZjWViHhw5cvBAUxUEqB', productionKey: '2cMNConFW8HNy7on58iuLYTBFb6' },
  },
  LiberOnlinebok: {
    rudder: { acceptanceKey: '2eJE5N5CpGG9GmXiDwWkIcolHNk', productionKey: '2eJEBmQsFNk1UUIXpOtsQy9U9rB' },
  },
  Sowiso: {
    /* 3rd party website */
    rudder: { acceptanceKey: '2gFHykgVqCda0ydsAo8fBU8ZZHf', productionKey: '2gFIBv6ZTfbU6ihcpybY0M5RF2U' },
  },
  Edify: {
    /* Edify 2.0 */
    rudder: { acceptanceKey: '2hPlSj9mvT9G1hjL8ucx1KIFHIx', productionKey: '2hPllx5nCtgPrsVknqWxLQfEMK4' },
  },
} as const;

export type Platform = typeof platforms extends ReadonlyArray<infer P> ? P : never;

export type BatchConfig = { readonly disabled?: boolean; readonly size?: number; readonly timeoutMs?: number };

export type PlatformConfiguration = {
  readonly rudder?: RudderConfiguration;
  readonly gtm?: GTMConfiguration;
};

export type RudderConfiguration = {
  readonly acceptanceKey?: string;
  readonly productionKey?: string;
  readonly startImmediately?: boolean;
};

export type GTMConfiguration = {
  readonly enabled: boolean;
  readonly startImmediately?: boolean;
};

export default platformConfiguration;
